import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Toaster } from 'react-hot-toast';
import { fetchUser, logout, setAuthChecked } from './store/slices/userSlice';
import AppRoutes from './routes/AppRoutes';
import AppErrorBoundary from './components/AppErrorBoundary';

function App() {
  const dispatch = useDispatch();
  
  useEffect(() => {
    // Restore user session
    if (localStorage.getItem('token')) {
      dispatch(fetchUser()).catch(() => {
        // Authentication errors are handled by the response interceptor and
        // protected route. Avoid an unhandled rejected promise during boot.
      });
    }
    else dispatch(setAuthChecked(true));

    // Register Firebase service worker
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
      .register("/firebase-messaging-sw.js")
        .catch(() => {
          // Push is optional for the admin portal; the in-app UI remains usable.
        });
      }

      const handleExpiredSession = () => dispatch(logout());
      window.addEventListener('admin-session-expired', handleExpiredSession);
      return () => window.removeEventListener('admin-session-expired', handleExpiredSession);
    }, [dispatch]);
  return (
    <Router>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
        }}
      />
      <AppErrorBoundary>
        <AppRoutes />
      </AppErrorBoundary>
    </Router>
  );
}

export default App;
